import React from 'react';
import {isClinicBased, isClinicRequired, Referral} from 'referral';
import {Observable} from 'rxjs';
import {ClinicLocationInput} from './ClinicLocationInput';
import {OtherClinicLocationInput} from './OtherClinicLocationInput';
import {ServiceInClinicInput} from './ServiceInClinicInput';

type ClinicSectionProps = {
    referral: Referral;
    isSubmitting$: Observable<boolean>;
    requireClinicLocationInput?: boolean;
}
export const ClinicSection = ({
                                  referral,
                                  isSubmitting$,
                                  requireClinicLocationInput = false,
                              }: ClinicSectionProps
) => {
    if (!isClinicRequired(referral, requireClinicLocationInput)) {
        return null;
    }

    return (
        <>
            <ServiceInClinicInput referral={referral} isSubmitting$={isSubmitting$} requireClinicLocationInput={requireClinicLocationInput}/>
            <ClinicLocationInput referral={referral} isSubmitting$={isSubmitting$} requireClinicLocationInput={requireClinicLocationInput}/>
            {/*// BHPNPP-2515 {*/}
            {/*    !isClinicBased(referral) &&*/}
            {/*    <OtherClinicLocationInput referral={referral} isSubmitting$={isSubmitting$} requireClinicLocationInput={requireClinicLocationInput}/>*/}
            {/*}*/}
        </>
    );
}
